import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import baseService from '../services/base';

/**
 * EG-63 — mesma ação do `DownloadResponsesButton` (planilha de respostas), mas
 * como callback, para o `AuditHeader` disparar sem renderizar o botão dele.
 * Espelha `useEvidenceDownload`.
 */
export function useResponsesDownload() {
  const toast = useToast();
  const [isLoadingResponses, setLoadingResponses] = useState(false);

  const downloadResponses = async ({ surveyId, companyId, companyGroupId, formName }) => {
    setLoadingResponses(true);
    try {
      const response = await baseService.get(
        `/excel/download/new?description=${formName}&company_id=${companyId}&survey_id=${surveyId}&company_group_id=${companyGroupId}`,
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${formName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      toast({ title: 'Download concluído com sucesso', status: 'success', isClosable: true });
    } catch (error) {
      console.error('Erro ao fazer o download:', error);
      toast({ title: 'Erro ao fazer o download', status: 'error', isClosable: true });
    } finally {
      setLoadingResponses(false);
    }
  };

  return { downloadResponses, isLoadingResponses };
}
